export default __webpack_public_path__ + "13012407c099bc06e86072a59e11c813.svg";